// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"2407":"css/app.6969","4893":"css/admin-app.6969"}[chunkId] + ".css";
};